export default __webpack_public_path__ + "static/media/airlockz-bpk-2.0b069290.png";